export default function Footer() {
  return (
    <footer className="bg-gray-900 text-gray-300 mt-2 py-6">
      <div className="max-w-7xl mx-auto grid grid-cols-2 md:grid-cols-4 gap-4 text-sm">
        <div>
          <h4 className="font-semibold text-white mb-2">About</h4>
          <p>Aerth.com brings trusted brands and lightning-fast delivery.</p>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-2">Help</h4>
          <p>Payments</p>
          <p>Returns</p>
          <p>Track Orders</p>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-2">Social</h4>
          <p>Instagram</p>
          <p>Twitter</p>
          <p>Facebook</p>
        </div>
        <div>
          <h4 className="font-semibold text-white mb-2">Policy</h4>
          <p>Terms of Use</p>
          <p>Privacy</p>
        </div>
      </div>
      <p className="text-center text-xs text-gray-500 mt-4">
        © 2025 HRGF.com | Ecommerce Industries
      </p>
    </footer>
  );
}
